module.exports = __webpack_public_path__ + "5cd48c56e132e78b67c60526ee0430bd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/big-wig-s.png
// module id = 2158
// module chunks = 0